import moment from "moment";
import $ from "jquery";
import select2 from "select2";
import {setInfoValue} from "@/helpers/info-overview-helper";
import datepicker from "bootstrap-datepicker"
import {getWizardItemByAttributeID} from "@/helpers/smart-wizard-helper";

let localAttributeID

export function loadDateValues() {
    setInfoValue(localAttributeID, $('#iptNewNotificationDate-' + localAttributeID).val() + ' ' + $('#iptNotificationTime-' + localAttributeID).val())
}

export function initDatePicker(attributeID) {

    localAttributeID = attributeID

    const input = $('#iptNewNotificationDate-' + attributeID)

    input.val(moment().format('DD-MM-YYYY'))

    const wizardItem = getWizardItemByAttributeID(attributeID)

    $.fn.datepicker.dates['nl'] = {
        days:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],
        daysShort:["zo","ma","di","wo","do","vr","za"],
        daysMin:["zo","ma","di","wo","do","vr","za"],
        months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],
        monthsShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],
        today:"Vandaag",
        monthsTitle:"Maanden",
        clear:"Wissen",
        weekStart:1,
        format:"dd-mm-yyyy"
    };

    let options = {
        format: 'dd-mm-yyyy',
        weekStart: 1,
        language: 'nl'
    }

    if(wizardItem.Download === 1) {
        options.endDate = moment().format('DD-MM-YYYY')
    }

    input.datepicker(options).on('changeDate', function(e) {
        $(this).datepicker('hide');
        setInfoValue(attributeID, moment(e.date).format('DD-MM-YYYY') + ' ' + $('#iptNotificationTime-' + attributeID).val())
        loadTimePickerOptions(attributeID)
    });
}

export function initTimePicker(attributeID) {
    const input = $('#iptNotificationTime-' + attributeID)

    select2(input)
    input.select2({
        width: 'calc(100% - 15px)',
        data: [],
        language: {
            noResults: function () {
                return "Geen resultaten gevonden";
            }
        },
        tags: true,
    })

    input.one('select2:open', function(e) {
        $('input.select2-search__field').prop('placeholder', 'Vul hier zelf een tijdstip in');
    });

    loadTimePickerOptions(attributeID)
}

export function loadTimePickerOptions(attributeID) {

    const input = $('#iptNotificationTime-' + attributeID)
    const wizardItem = getWizardItemByAttributeID(attributeID)
    let dateToday = moment().format('HH:mm')

    input.html('')
    const checkDate = moment($('#iptNewNotificationDate-' + attributeID).val(), 'DD-MM-YYYY', 'nl')

    let dateHour = parseInt(moment().format('H'))
    let dateMinute = moment().format('mm')
    let dateHourCheck = dateHour

    const checkDiff = checkDate.diff(moment(), 'days')
    if(checkDiff < 0) {
        dateHourCheck = 24;
        dateMinute = 60
    }

    console.log(wizardItem)

    for(var i = 0; i <= 23; i++){

        let time = i

        if(i < 10) {
            time = '0' + time
        }

        if(wizardItem.Download !== 1 || i <= dateHourCheck) {
            input.append('<option value="' + time + ':00">' + time + ':00</option>')

            if(i === dateHour && dateMinute <= 30) {
                input.append('<option value="' + dateToday + '">' + dateToday + '</option>')
            }

            if(i < dateHourCheck || (i === dateHourCheck && dateMinute > 30)) {
                input.append('<option value="' + time + ':30">' + time + ':30</option>')
            }

            if(i === dateHour && dateMinute > 30) {
                input.append('<option value="' + dateToday + '">' + dateToday + '</option>')
            }
        }
    }

    input.val(dateToday)
    input.trigger('change.select2');
}

export function resetDatePicker() {
    $('.iptNotificationTime').val(moment().format('HH:mm'))
    $('.iptNotificationTime').trigger('change.select2');
}
